'use client'

/**
 * Шаг 5 импорта — финал (Intelligence Terminal §States).
 */

import { CheckCircle } from '@phosphor-icons/react'
import { cn } from '@/lib/utils'
import { useT } from '@/lib/i18n'

interface Props {
  onClose: () => void
}

export function StepCommit({ onClose }: Props) {
  const t = useT()
  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      <CheckCircle size={48} weight="fill" className="text-risk-low" />
      <h3 className="text-[16px] font-medium text-[var(--text-primary)]">
        {t('importWizard.commit.title')}
      </h3>
      <p className="max-w-md text-[13px] text-[var(--text-secondary)]">
        {t('importWizard.commit.lead')}
      </p>
      <button
        type="button"
        onClick={onClose}
        className={cn(
          'inline-flex items-center gap-1.5 rounded-[4px] px-3 py-1.5 text-[12px] font-medium',
          'transition-colors duration-150',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-data)] focus-visible:ring-offset-2',
          'bg-accent-data text-fg-on-risk',
        )}
      >
        {t('common.action.close')}
      </button>
    </div>
  )
}
